var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.$style.button,attrs:{"disabled":_vm.disabled}},[(_vm.loading)?_c('CircularButtonLoader'):_c('span',[_vm._v(_vm._s(_vm.$t("headline")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }